import {combineReducers} from "redux";

import preloader from "./reducres/preloader";
import sidebar from "./reducres/sidebar";
import popup from "./reducres/popup";
import modal from "./reducres/modal";
import user from "./reducres/user";
import like from "./reducres/like";
import favorite from "./reducres/favorite";
import recent_channel from "./reducres/recent.channel";

const rootReducer = combineReducers({
    preloader, sidebar, popup, user, modal, like, favorite, recent_channel,
});
export default rootReducer;


// WEBPACK FOOTER //
// ./src/libs/redux/reducer.js